module.exports = __webpack_public_path__ + "static/media/021-sunrise.8dde4d51.svg";